import type { ReactElement } from 'react';
import React from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { Icon } from '../../Icon';
import { useIconStyles } from '../styles';

import type { ButtonIconProps } from '../Button.types';

export const BUTTON_ICON_TEST_ID = 'button-icon';

export const ButtonIcon = (props: ButtonIconProps): ReactElement | null => {
  const {
    centerIcon,
    iconSize,
    leftIcon,
    rightIcon,
    palette,
    size,
    hasDisabledStyle,
    uiEventState,
  } = props;

  const useStyleState = useIconStyles(palette, size);
  const styledState = useStyleState(hasDisabledStyle, uiEventState);
  const flatStyle = StyleSheet.flatten(styledState) as IconProps;
  const { width, color } = useStyle(() => flatStyle, [flatStyle]);
  const name = centerIcon ?? leftIcon ?? rightIcon;
  const resolvedIconSize = iconSize ?? width;

  const positionStyle = centerIcon ? {} : leftIcon ? styles.left : styles.right;
  const style = [styles.button, styledState, positionStyle];

  if (!name) return null;

  return (
    <Text testID={BUTTON_ICON_TEST_ID} style={style}>
      <Icon name={name} color={color} width={resolvedIconSize} height={resolvedIconSize} />
    </Text>
  );
};

const styles = StyleSheet.create({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: Platform.OS === 'ios' ? 20 : 24,
  },
  left: {
    marginRight: 4,
  },
  right: {
    marginLeft: 4,
  },
});

type IconProps = Readonly<{
  width: number;
  color: string;
}>;
